import { ReactNode } from 'react'

export const PdfPage = ({ children }: { children: ReactNode }) => {
  return <div className='l-pdf-page__single'>{children}</div>
}
